import React, { FC } from 'react'
import LogoSpinner from '../../assets/img/logo-filled.png'
import './styles.scss'

const Spinner: FC = () => {
  return (
    <div className="spinner">
      <img src={LogoSpinner} alt="maverick-spinner" />
    </div>
  )
}

export default Spinner
